module.exports = __webpack_public_path__ + "static/media/Lafayette Cam 05.b14cb2db.webp";